<template>
  <label class="checkbox-switch" :class="{ disabled: disabled }">
    <input
      type="checkbox"
      :checked="model"
      :disabled="disabled"
      @change="onChange($event.target.checked)"
    />
    <span class="checkbox-switch__visible"></span>
    <span class="checkbox-switch__text">{{ $t(text) }}</span>
  </label>
</template>

<script>
export default {
  name: "CheckBox",
  props: {
   
    value: {
      type: Boolean,
      default: false,
    },
   
    modelValue: {
      type: Boolean,
      default: undefined, 
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    model() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
  },
  methods: {
    onChange(val) {
      this.$emit("input", val); 
      this.$emit("update:modelValue", val);  
    },
  },
};
</script>


<style scoped>
.checkbox-switch.disabled { 
  cursor: not-allowed;
  opacity: 0.5;
}
</style>